import React from "react";
import { FormattedMessage } from "@irati/utils/lang";
import { Body, H6 } from "@irati/ui/src/Typography";
var StepTwo = function () {
    var boldText = (React.createElement(Body, { small: true, weight: "bold" },
        React.createElement(FormattedMessage, { id: "platform.home.tour.stepTwo.boldText" })));
    return (React.createElement(React.Fragment, null,
        React.createElement(H6, { marginBottom: true },
            React.createElement(FormattedMessage, { id: "platform.home.tour.stepTwo.header" })),
        React.createElement(Body, { small: true },
            React.createElement(FormattedMessage, { id: "platform.home.tour.stepTwo.desc", values: { boldText: boldText } }))));
};
export default StepTwo;
